import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/pt';

import InsightcareLocalFooter from './components/InsightcareLocalFooter';
import InsightcareHeader from './components/InsightcareHeader';
import ProgressBar from './components/Progress';
import Loading from './components/Loading';
import { BACKEND_INS_URL } from './config/constants';

import AuxRoutines from './AuxRoutines';
import Select from 'react-select';
import PdfPacientesLiberacaoDieta from './components/PdfPacientesLiberacaoDieta';
//require('moment/locale/pt-BR');

class PainelPacientesLiberacaoDieta extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    this.state = {
      cycle: 0,
      loading: true,
      totalCycles: 0,
      pacientes: [],
      serachPacientes: [],
      filteredPacientes: [],
      numberOfElements: 0,
      base: params.base,
      idLocal: params.idLocal,
      theme: (params.theme === 'dark' ? 'dark' : 'light'),
      iconText: (params.theme === 'dark' ? '_dark' : ''),
      locationName: AuxRoutines.getLocationName(params.base, params.idLocal),
      boolFoward: 1,
      boolPause: 0,
      interval: 0,
      intervalValue: 0,
      value: 0,
      test: '',
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
  }

  componentDidMount() {
    //Carrega o local se existe
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
    if (this.state.theme === 'dark') {
      document.body.style.backgroundColor = "black";
    }
    this.moveProgress();
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }

  async loadingBar(time) {
    return await new Promise(resolve => {
      this.setState({
        intervalValue: setInterval(async () => {
          resolve('load');
          const newValue = this.state.value + 1;
          if (newValue <= 100 && this.state.boolPause === 0 && this.state.filteredPacientes.length !== 1) {
            this.setState({
              value: newValue,
            });
          }
        }, time),
      });
    });
  }

  moveProgress() {
    clearInterval(this.state.interval);
    clearInterval(this.state.intervalValue);
    if (this.state.boolPause === 0) {
      this.loadingBar(200).then(() => { console.log('loading') });
      this.setState({
        interval: setInterval(async () => {
          this.setState({
            value: 0,
          });
          this.loadRequiredData();
        }, 20000),
      });
    }
  }

  pauseProgress() {
    clearInterval(this.state.intervalValue);
    clearInterval(this.state.interval);
  }

  async loadRequiredData() {
    let sliceSize = 8;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles === 0) {
        cycle = 0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }
  }

  changeCycle(boolFoward) {
    let sliceSize = 8;
    if (boolFoward === 0) {
      if (this.state.cycle === 1) {
        this.setState({ cycle: this.state.totalCycles, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.totalCycles - 1)), sliceSize + (sliceSize * (this.state.totalCycles - 1))) })
      } else {
        this.setState({ cycle: this.state.cycle - 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * (this.state.cycle - 2)), sliceSize + (sliceSize * (this.state.cycle - 2))) })
      }
    } else if (boolFoward === 1) {
      this.loadRequiredData();
    }
    this.setState({
      value: 0,
    });
  }

  actionPause(boolPause) {
		if (boolPause === 0) {
			this.setState({ boolPause: 1 }, () => {
				this.pauseProgress();
			});
		}
		if (boolPause === 1) {
			this.setState({ boolPause: 0 }, () => {
				this.moveProgress();
			});
		}
  }

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
    let url = BACKEND_INS_URL + '/cli-prontuario-prescricao-dieta/get-pacientes-liberacao-dieta?sharedSecret=hd783g4kshd7f9fhalu&token=QYv6eY9v6w2WRVWzoyMCMJc3uuW3Z-79';
    if (this.state.idLocal !== undefined && this.state.idLocal !== 'all') {
      url = url + '&idLocal=' + this.state.idLocal;
    }

    let response = await axios.get(url);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ReturnData.Data.sort((a, b) => a.MinutosInicio > b.MinutosInicio ? 1 : -1);
      
    }

    this.setState({
      serachPacientes: returnData,
      filteredPacientes: this.state.filteredPacientes.length !== 0 ? this.state.filteredPacientes : returnData,
      locationName: response.data.ReturnData.LocationName,
    });
    return returnData;
  }

  textoGrupoPacientes(ciclo, totalCiclos, totalElementos) {
    if (this.state.filteredPacientes.length === 1) {
      return "Mostrando de 1 a 1, de 1 paciente";
    }
    else {
      var de = (ciclo <= 1) ? ciclo : (ciclo - 1) * 8;
      var ate = (ciclo === totalCiclos) ? totalElementos : ciclo * 8;
      return "Mostrando de " + de + " a " + ate + ", de " + totalElementos + " pacientes";
    }
  }

  changeTheme() {
    this.setState({ loading: true });
    this.setState(prevState => ({
      theme: prevState.theme === 'light' ? 'dark' : 'light',
    }));

    var $path = '/painel/pacientes-liberacao-dieta/' + this.state.idLocal;

    if (this.state.theme === 'light') {
      $path = $path + '/dark';
    }
    window.location.href = $path;
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const loading = this.state.loading;
    const theme = this.state.theme;
    return (
      <div className={"App " + theme}>
        {
          loading
            ? (<Loading />)
            : (
              <div>
                <InsightcareHeader title="Liberação de Dietas" theme={theme} />
                <main className={"content " + theme} id="panel1Styled">
                  <ProgressBar value={this.state.value} max={100} theme={theme} />
                  <div className={"inforow " + theme}>
                    <div className={'inforow right ' + theme}>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(0)} ><img src={"/img/icon_arrow_left" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeCycle(1)}><img src={"/img/icon_arrow_right" + this.state.iconText + ".svg"} alt="" /></button>
                      <button className={'buttonIcon ' + theme} onClick={() => this.actionPause(this.state.boolPause)}><img src={(this.state.boolPause === 1 ? "/img/icon_play" : "/img/icon_pause") + this.state.iconText + ".svg"} alt="" /></button>
                      <div className='infoText'>{this.textoGrupoPacientes(this.state.cycle, this.state.totalCycles, this.state.numberOfElements)}</div>
                    </div>

                    <div className={'inforow left ' + theme}>
                      <div className='infoText'>Agora são {this.state.currentDateHour}</div>
                      <PdfPacientesLiberacaoDieta title={"Liberação de Dietas"} list={(this.state.filteredPacientes.length === 0) ? this.state.serachPacientes : this.state.filteredPacientes} theme={theme} />
                      <form>
                        <div className={'buttonSearch ' + theme}>
                          <img src={"/img/icon_search" + this.state.iconText + ".svg"} alt="" />
                          <Select className={'selectSearch ' + theme}
                            placeholder="Busque por um paciente ou atendimento..."
                            options={
                              this.state.serachPacientes.map(opt => ({
                                key: opt.ID + opt.DataHoraInicio,
                                label: opt.Paciente + " \n(" + opt.CodigoAtendimento.toLowerCase() + ")",
                                value: opt.CodigoAtendimento,
                                nome: opt.Paciente,
                                atendimento: opt.CodigoAtendimento,
                              }))}
                            onFocus={opt => {
                              this.actionPause(0);
                            }}
                            onBlur={opt => {
                              this.actionPause(1);
                            }}
                            isClearable={true}
                            onChange={opt => {
                              if (opt !== null && opt !== '') {
                                const pessoa = this.state.serachPacientes.find((elem) => (elem.Paciente === opt.nome && elem.CodigoAtendimento === opt.atendimento));

                                if (pessoa) {
                                  this.setState({
                                    filteredPacientes: [pessoa],
                                  });
                                } else {
                                  this.setState({
                                    filteredPacientes: this.state.serachPacientes,
                                  });
                                }
                              } else {
                                this.setState({
                                  filteredPacientes: this.state.serachPacientes,
                                });
                              }
                            }}
                          />
                        </div>
                      </form>
                      <button className={'buttonIcon ' + theme} onClick={() => this.changeTheme()}><img src={"/img/icon_theme" + this.state.iconText + ".svg"} alt="" /></button>
                    </div>
                  </div>

                  <table className={'table table-striped' + (theme === 'dark' ? '-dark' : '')}>
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Dieta Vigente</th>
                        <th>Paciente</th>
                        <th>Leito</th>
                        <th>Tempo</th>
                      </tr>
                    </thead>
                    <tbody className={theme}>
                      {
                        (this.state.filteredPacientes.length === 1
                          ? this.state.filteredPacientes
                          : this.state.pacientes)
                          .map((data) => {
                            let color = '';
                            let tdClassFarm = "";
                            let spanClassFarm = "";
                            let name = data.Paciente;
                            var days = 0;
                            var rdays = 0;
                            var hours = 0;
                            var rhours = 0;
                            var minutes = 0;
                            var rminutes = 0;

                            let key = "tr-" + data.CodigoAtendimento + data.DataHoraInicio;
                            
                            if(data.MinutosInicio <= 15) {
                              spanClassFarm = "warning-circle";
                            } else {
                              spanClassFarm = "attention-circle";
                            }
                            let time = data.MinutosInicio;
                            if (data.MinutosInicio > 60) {
                              if (data.MinutosInicio > 1440) {
                                days = (data.MinutosInicio / 1440);
                                rdays = Math.floor(days);
                                hours = (days - rdays) * 24;
                                rhours = Math.floor(hours);
                                minutes = (hours - rhours) * 60;
                                rminutes = Math.round(minutes);
                                time = rdays + " d " + rhours + " h " + rminutes + " m";
                              } else {
                                hours = (data.MinutosInicio / 60);
                                rhours = Math.floor(hours);
                                minutes = (hours - rhours) * 60;
                                rminutes = Math.round(minutes);
                                time = rhours + " h " + rminutes + " m";
                              }
                            } else {
                              time = time + ' mins';
                            }
                            return (
                              <tr key={key}>
                                <td style={{ color: color }} align="left" className='infoText'><b>{data.Status}</b></td>
                                <td style={{ color: color }} align="left" className='infoText'>{data.DietaVigente}</td>
                                <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', color: color }} align="left" className='infoText'><b>{name}</b> | ({data.CodigoAtendimento})</td>
                                <td style={{ color: color }} align="left">{<b>{data.Leito}</b>}</td>
                                <td className={tdClassFarm} align="left"><span className={spanClassFarm}></span>{time}</td>
                              </tr>
                            )
                          })
                      }
                    </tbody>
                  </table>
                </main>
                <InsightcareLocalFooter hospitalName={this.state.locationName} theme={theme} />
              </div>
            )
        }
      </div>
    );
  }
}

export default PainelPacientesLiberacaoDieta;
